import { browserLogger } from '@widget/utils/datadog';

import type { StepDataMap } from '../types';

export function getSkippedFields(stepDataMap: StepDataMap) {
  try {
    const result: Record<string, unknown> = {};

    for (const stepValues of Object.values(stepDataMap)) {
      for (const [key, value] of Object.entries(stepValues)) {
        result[key] = value;
      }
    }

    return result;
  } catch (error) {
    browserLogger.error(error, 'get skipped fields on lead submit');
    return {};
  }
}
